module.exports = __webpack_public_path__ + "static/media/rugrats-logo.2a4c5f1b.png";